// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__2JxX2","fileBtn":"File_fileBtn__36fMk","closeBtn":"File_closeBtn__L6nb2","fileSelected":"File_fileSelected__2DnTL","disabled":"File_disabled__F4FVW"};